import { memo, useCallback, forwardRef } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import PropTypes from 'prop-types';

const CloseWindow = forwardRef(({ closeHandler, tabIndex }, ref) => {
    const handleClick = useCallback(
        (e) => {
            e.stopPropagation();
            closeHandler();
        },
        [closeHandler]
    );

    return (
        <Tooltip title="Close [Esc]">
            <IconButton sx={{ padding: '0.25rem' }} aria-label="close" onClick={handleClick} tabIndex={tabIndex} ref={ref}>
                <CloseIcon sx={{ width: '1.5rem', height: '1.5rem', color: '#fff' }} />
            </IconButton>
        </Tooltip>
    );
});

CloseWindow.displayName = 'CloseWindow';

CloseWindow.propTypes = {
    closeHandler: PropTypes.func.isRequired,
    tabIndex: PropTypes.number,
};

export default memo(CloseWindow);
